import { includes } from 'lodash'
import React, { createContext, ReactNode } from 'react'
import { connect } from 'react-redux'
import { PermissionsEnum } from '../../../constants'
import { AUTH_LOADING_STATE, PermissionResponse } from './constants'

export interface PermissionContextProps {
  permissions: PermissionResponse[]
  hasPermission: (permission: PermissionsEnum) => boolean
  permissionsLoading: boolean
}

interface ProviderProps {
  children: ReactNode
  permissions: PermissionResponse[]
  permissionsLoading: boolean
}

export const PermissionsContext = createContext<PermissionContextProps | {}>({})

const Provider = ({
  children,
  permissions,
  permissionsLoading,
}: ProviderProps) => {
  const hasPermission = (permission: PermissionsEnum) => {
    return permissions.some(item => {
      return item.request.permission === permission && item.permitted
    })
  }
  return (
    <PermissionsContext.Provider
      value={{ permissions, permissionsLoading, hasPermission }}
    >
      {children}
    </PermissionsContext.Provider>
  )
}

const mapStateToProps = (state: any) => {
  return {
    permissionsLoading: includes(
      AUTH_LOADING_STATE,
      state['APEX_LEGIT_AUTHORIZATION']?.status
    ),
    permissions: state['APEX_LEGIT_AUTHORIZATION']?.results?.permissions || [],
  }
}

export const PermissionsProvider = connect(mapStateToProps)(Provider)
